import "@fortawesome/fontawesome-free/css/all.min.css";
import React from "react";
import "./ReservationButton.css";

const ReservationButton = () => {
  const buttonClick = () => {
    window.open("https://maya-sapanca.hotelrunner.com/bv3/search", "_blank");
  };

  return (
    <div className="location-container">
      <button
        className="location-button"
        aria-label="Rezervasyon"
        onClick={buttonClick}
      >
        <i className="fa-regular fa-calendar-check"></i>
      </button>
    </div>
  );
};

export default ReservationButton;
